// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { send } from '../../actions/network';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';

import HistoryItemDetail from './HistoryItemDetail';
import legacyHistoryItemDetailPropsSelector from './legacyHistoryItemDetailPropsSelector';

const HistoryItemDetailContainer = () => {
  const {
    params: { betslipReference: betslipReferenceFromParams },
    location: { state },
  } = useRouter();
  const { betslipReference: betslipReferenceFromState } = state ?? {};

  const selectedProps = useSelector((state) =>
    legacyHistoryItemDetailPropsSelector(state, {
      betslipReference: betslipReferenceFromParams || betslipReferenceFromState,
    }),
  );

  const actions = useMemo(
    () => ({
      askBetslipInfo: (betslipRef) => {
        return send({ getOneBetslip: { betslipReference: betslipRef } });
      },
    }),
    [],
  );

  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ selectedProps, actionsProps });

  return <HistoryItemDetail {...enhancedProps} />;
};

export default HistoryItemDetailContainer;
